import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { useCallback, useState } from "react";

import StylesDashboard from "./StylesDashboard";
import StylesAnalytics from "./StylesAnalytics/StylesAnalytics";

/** Analytics on top (with More Filters), styles table below — both scoped by the table's filters. */
const StylesDashboardShell = () => {
	const [scope, setScope] = useState({ filter: {}, search: "" });
	const [filterUi, setFilterUi] = useState({ open: () => {}, count: 0 });
	const onFilterUiChange = useCallback((api) => {
		setFilterUi(api || { open: () => {}, count: 0 });
	}, []);

	return (
		<Stack spacing={1.5} sx={{ width: "100%" }}>
			<StylesAnalytics
				filter={scope.filter}
				search={scope.search}
				onMoreFilters={filterUi.open}
				activeFilterCount={filterUi.count}
			/>
			<Box sx={{ width: "100%" }}>
				<StylesDashboard onFilterChange={setScope} onFilterUiChange={onFilterUiChange} />
			</Box>
		</Stack>
	);
};

export default StylesDashboardShell;
